import { ErrorHandler, inject, Injectable } from "@angular/core";
import { MessageService } from "primeng/api";

@Injectable({
    providedIn:'root'
})
export class GlobalErrorHandler implements ErrorHandler {
    private messageService = inject(MessageService)
    handleError(error: any): void {
      console.log("error handler is called", error);
      //TODO: add this error message to backend API 
      if ((error.message as string).includes('dynamically imported module')) {
        error.message = 'Please refresh your page or restart your browser, if issue still happen please contact support@ammall.com'
      }
      this.messageService.add({
               summary: 'Error',
               severity: 'error',
               detail: error.message || error.message.trim() != "" ? error.message : "Unkown error please retry" ,
               key: 'general-notification',
             });
    }

}